import { render, staticRenderFns } from "./CompLesson.vue?vue&type=template&id=ca035d92&scoped=true&"
import script from "./CompLesson.vue?vue&type=script&lang=js&"
export * from "./CompLesson.vue?vue&type=script&lang=js&"
import style0 from "./CompLesson.vue?vue&type=style&index=0&id=ca035d92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca035d92",
  null
  
)

export default component.exports